
import { dateDisplay } from "../functions";

import countdown from "countdown";

// Date format options info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options

$(function () {
    dateDisplay();

    const countdownEls = $('.js-date-display-countdown');
    if (countdownEls.length) {
        function dateDisplayCountdownTimer() {
            countdownEls.each(function() {
                const $this = $(this),
                    msTimestamp = parseInt($this.data('mstimestamp'));
                let countdownEndedMessage = $this.data('countdown-ended-message');
                if (isNaN(msTimestamp)) return;
                if (!countdownEndedMessage) countdownEndedMessage = hpaTranslatedtext.dateDisplay.webinarHasStarted; // Webinar has started
                let value = countdown(new Date(msTimestamp)).toString();

                if (Date.now() > msTimestamp) {
                    value = countdownEndedMessage;
                    $this.html(value);
                    return true;
                }

                $this.html(value);

                setTimeout(function() {
                    dateDisplayCountdownTimer();
                }, 1000);
            });
        }
        dateDisplayCountdownTimer();
    }
});



// WEBPACK FOOTER //
// ./js/modules/dateDisplay.js